<template>
  <div class="chart-card" :class="{ 'is-compact': compact, 'is-ultra-compact': ultraCompact }">
    <div class="card">
      <div class="card-header">
        <h5 class="card-title">{{ title }}</h5>
      </div>
      <div class="card-body">
        <skeleton-loader v-if="loading" />
        <div v-else-if="isEmpty" class="empty-state">
          <p>{{ emptyText }}</p>
        </div>
        <slot v-else></slot>
      </div>
    </div>
  </div>
</template>

<script>
import SkeletonLoader from './SkeletonLoader.vue';

export default {
  components: {
    SkeletonLoader
  },
  props: {
    title: {
      type: String,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    isEmpty: {
      type: Boolean,
      default: false
    },
    emptyText: {
      type: String,
      default: 'No data available'
    },
    compact: {
      type: Boolean,
      default: false
    },
    ultraCompact: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss" scoped>
.chart-card {
  .card {
    height: 100%;
    margin-bottom: 0;

    .card-header {
      padding: 1.25rem 1.5rem 0.75rem;
      border-bottom: none;

      .card-title {
        margin-bottom: 0;
        font-size: 1.1rem;
        font-weight: 500;
      }
    }

    .card-body {
      padding: 0.75rem 1.5rem 1.5rem;
      overflow-x: auto;
    }

    .empty-state {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 180px;
      color: #b9b9c3;
    }
  }

  &.is-compact {
    .card {
      .card-header {
        padding: 1rem 1.25rem 0.5rem;

        .card-title {
          font-size: 1rem;
        }
      }

      .card-body {
        padding: 0.5rem 1.25rem 1.25rem;
      }
    }
  }

  &.is-ultra-compact {
    .card {
      .card-header {
        padding: 0.75rem 1rem 0.25rem;

        .card-title {
          font-size: 0.9rem;
        }
      }

      .card-body {
        padding: 0.25rem 1rem 1rem;
      }

      .empty-state {
        height: 120px;
      }
    }
  }
}
</style>
